import { reactive } from 'vue';

export const store = reactive({
  selectedCoin: 'bitcoin',
  date: ''
});
